(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3850],{

/***/ 3850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content006": function() { return /* binding */ Content006; },
  "default": function() { return /* binding */ Content006_Content006; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./src/components/widgets/content/Content006/Content006.module.scss
var Content006_module = __webpack_require__(21098);
var Content006_module_default = /*#__PURE__*/__webpack_require__.n(Content006_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./src/shared/components/Tabs/Tabs.Provider.js
var Tabs_Provider = __webpack_require__(11742);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/shared/components/LazyRenderingButton/index.js + 3 modules
var LazyRenderingButton = __webpack_require__(41141);
// EXTERNAL MODULE: ./src/shared/components/Tabs/Tabs.hooks.js
var Tabs_hooks = __webpack_require__(60419);
// EXTERNAL MODULE: ./src/components/widgets/content/Content006/Item/index.js + 1 modules
var Item = __webpack_require__(44233);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content006/GridItem/GridItem.jsx







var GridItem = function(param) {
    var items = param.items, className = param.className;
    var ref = (0,LazyRenderingButton/* useLazyRenderingState */.vO)(), limit = ref.limit, resetState = ref.resetState;
    var ref1 = (0,Tabs_hooks/* useTabsState */.n)(), activeTab = ref1.activeTab, isDefaultTab = ref1.isDefaultTab, tabsEnabled = ref1.tabsEnabled;
    var filteredItems = (0,react.useMemo)(function() {
        if (isDefaultTab || !tabsEnabled) {
            return items;
        }
        return items.filter(function(param) {
            var tag = param.tag;
            return tag.toLowerCase() === activeTab.toLowerCase();
        });
    }, [
        isDefaultTab,
        tabsEnabled,
        items,
        activeTab
    ]);
    var slicedItems = (0,react.useMemo)(function() {
        return filteredItems.slice(0, limit);
    }, [
        filteredItems,
        limit
    ]);
    (0,react.useEffect)(function() {
        if (tabsEnabled) {
            resetState();
        }
    }, [
        activeTab,
        resetState,
        tabsEnabled
    ]);
    return slicedItems.map(function(item) {
        return /*#__PURE__*/ (0,react.createElement)(Item/* Item */.c, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: className
        }, item), {
            key: item.id
        }));
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content006/GridItem/index.js


// EXTERNAL MODULE: ./src/components/widgets/content/Content006/GridView/GridView.module.scss
var GridView_module = __webpack_require__(52350);
var GridView_module_default = /*#__PURE__*/__webpack_require__.n(GridView_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content006/GridView/GridView.jsx








var GridView = function(param) {
    var items = param.items, title = param.title, description = param.description, extractedTabs = param.extractedTabs, tabsEnabled = param.tabsEnabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Container */.W2, {
                className: (GridView_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (GridView_module_default()).title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs_Provider/* TabsProvider */.X, {
                items: extractedTabs,
                defaultTab: true,
                tabsEnabled: tabsEnabled,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
                        className: (GridView_module_default())["tabs-wrapper"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Tabs */.mQ, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (GridView_module_default()).blocks,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (GridView_module_default()).wrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                                items: items,
                                className: classnames_default()((GridView_module_default()).item, (0,_define_property/* default */.Z)({}, (GridView_module_default()).single, items.length === 1))
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content006/GridView/index.js


// EXTERNAL MODULE: ./src/components/widgets/content/Content006/MobileSliderView/MobileSliderView.module.scss
var MobileSliderView_module = __webpack_require__(76546);
var MobileSliderView_module_default = /*#__PURE__*/__webpack_require__.n(MobileSliderView_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content006/MobileSliderView/MobileSliderView.jsx







var MobileSliderView = function(param) {
    var items = param.items, title = param.title, description = param.description, extractedTabs = param.extractedTabs, tabsEnabled = param.tabsEnabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Container */.W2, {
        className: (MobileSliderView_module_default()).header,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (MobileSliderView_module_default()).top,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (MobileSliderView_module_default())["top-content"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (MobileSliderView_module_default()).title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                            color: "grey",
                            className: (MobileSliderView_module_default()).description,
                            children: description
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs_Provider/* TabsProvider */.X, {
                items: extractedTabs,
                defaultTab: true,
                tabsEnabled: tabsEnabled,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (MobileSliderView_module_default())["top-navigation"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Tabs */.mQ, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LazyRenderingButton/* LazyRenderingProvider */.Bv, {
                        size: items.length,
                        initialLimit: 3,
                        incrementBy: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MobileSliderView_module_default()).wrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                                    items: items,
                                    className: (MobileSliderView_module_default()).item
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LazyRenderingButton */.WJ, {
                                appearance: "light"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content006/MobileSliderView/index.js


// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content006/SliderView/index.js

var DynamicSliderView = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3478).then(__webpack_require__.bind(__webpack_require__, 73478));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73478)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content006/Content006.jsx








var Content006 = function(param) {
    var payload = param.payload;
    var isMobile = (0,ViewMode/* useViewMode */.mJ)().isMobile;
    var ref;
    var type = (ref = payload === null || payload === void 0 ? void 0 : payload.type) !== null && ref !== void 0 ? ref : "grid";
    var ref1;
    var title = (ref1 = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var description = (ref2 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    var items = (ref3 = payload === null || payload === void 0 ? void 0 : payload.items) !== null && ref3 !== void 0 ? ref3 : [];
    var ref4;
    var tabsEnabled = (ref4 = payload === null || payload === void 0 ? void 0 : payload.showTabs) !== null && ref4 !== void 0 ? ref4 : false;
    var extractedTabs = (0,_to_consumable_array/* default */.Z)(new Set(items.map(function(item) {
        return item.tag;
    })));
    if (type === "grid") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Content006_module_default()).wrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridView, {
                items: items,
                title: title,
                description: description,
                tabsEnabled: tabsEnabled,
                extractedTabs: extractedTabs
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Content006_module_default()).wrapper,
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSliderView, {
            items: items,
            title: title,
            description: description,
            tabsEnabled: tabsEnabled,
            extractedTabs: extractedTabs
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSliderView, {
            items: items,
            title: title,
            description: description,
            tabsEnabled: tabsEnabled,
            extractedTabs: extractedTabs
        })
    });
};
/* harmony default export */ var Content006_Content006 = (Content006);


/***/ }),

/***/ 44233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* reexport */ Item; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./src/components/widgets/content/Content006/Item/Item.module.scss
var Item_module = __webpack_require__(56428);
var Item_module_default = /*#__PURE__*/__webpack_require__.n(Item_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content006/Item/Item.jsx






var Item = function(param) {
    var className = param.className, title = param.title, subTitle = param.subTitle, description = param.description, media = param.media;
    var ref = (0,react.useState)(false), stateItem = ref[0], setStateItem = ref[1];
    var openItem = (0,react.useCallback)(function() {
        return stateItem ? setStateItem(false) : setStateItem(true);
    }, [
        stateItem
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Action */.aU, {
        onClick: openItem,
        className: classnames_default()((Item_module_default()).wrapper, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageLite */.NH, {
                image: media,
                className: (Item_module_default()).logo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Item_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Item_module_default()).block,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (Item_module_default()).lead,
                        children: subTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* RenderIf */.$b, {
                        viewMode: ViewMode/* VIEW_MODES.MOBILE */.nY.MOBILE,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                className: stateItem ? classnames_default()((Item_module_default()).icon, (Item_module_default())["icon-open"]) : (Item_module_default()).icon,
                                name: "dropdown_arrow"
                            }),
                            stateItem && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (Item_module_default()).text,
                                children: description
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RenderIf */.$b, {
                viewMode: ViewMode/* VIEW_MODES.DESKTOP */.nY.DESKTOP,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (Item_module_default()).text,
                    children: description
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content006/Item/index.js



/***/ }),

/***/ 21098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content006_wrapper__IqEQV","header":"Content006_header__iJOu3","title":"Content006_title__NP8KK","description":"Content006_description__RBL__"};

/***/ }),

/***/ 52350:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GridView_wrapper__t12HY","item":"GridView_item__OtnbH","single":"GridView_single__nb_4p","header":"GridView_header__uPBwS","title":"GridView_title__WrwO7","tabs-wrapper":"GridView_tabs-wrapper__0DaHJ","blocks":"GridView_blocks__ov_pB"};

/***/ }),

/***/ 56428:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Item_wrapper__K44yY","block":"Item_block__TV4tq","logo":"Item_logo__VQs_5","title":"Item_title__aI6lF","lead":"Item_lead__PMLmi","text":"Item_text__IYSe7","icon":"Item_icon__Bprv8","icon-open":"Item_icon-open__aA1j5"};

/***/ }),

/***/ 76546:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MobileSliderView_wrapper__obkiv","top-content":"MobileSliderView_top-content__JyvG3","title":"MobileSliderView_title__9Tfg_","description":"MobileSliderView_description__nttjO","top-navigation":"MobileSliderView_top-navigation__nB0Dw","item":"MobileSliderView_item__lh4yd"};

/***/ })

}]);